import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import React, { useContext, useState } from 'react';
import { FiltersContext } from '../../../pages/NRReportTabs/NRReportFilterContextWrapper';
import NRRemediationContent from '../../NRRemediation/NRRemediationContent/NRRemediationContent';
import { RemediationContext } from '../../NRRemediation/NRRemediationContext';
import NRRemediateVulnerabilityButton from '../../NRReactGridCustomComponents/NRRemediateVulnerabilityButton/NRRemediateVulnerabilityButton';
import { DRAWER_WIDTH, DrawerHeader, DrawerMainContainer } from '../../NRDashboardCharts/NRClickThroughDrawer/NRClickThroughDrawer';
import NRLicenseIssueRemediationContent from '../../NRRemediation/NRLicenseIssueRemediation/NRLicenseIssueRemediationContent';

function RemediationButtonDrawerContainer({ row, mr = 3, isLicenseIssue = false }) {
  const { setOpenDrawer } = useContext(FiltersContext);
  const { setCVEs } = useContext(RemediationContext);
  const [openLocalDrawer, setOpenLocalDrawer] = useState(false);

  const onSubmit = form => {
    !!form.downloadSBOM && setOpenDrawer(false);
    setOpenLocalDrawer(false);
  };

  function handleClick() {
    setCVEs([row]);
    setOpenLocalDrawer(true);
  }

  function handleClose() {
    setOpenLocalDrawer(false);
  }

  return (
    <Box mr={mr} ml={'auto'}>
      <NRRemediateVulnerabilityButton row={row} handleOnClick={handleClick} />
      <Drawer
        disableBackdropTransition
        transitionDuration={0}
        hideBackdrop={true}
        PaperProps={{ sx: { width: DRAWER_WIDTH } }}
        anchor={'right'}
        open={openLocalDrawer}
        variant={'temporary'}
      >
        <DrawerMainContainer>
          <DrawerHeader drawerTitle={`Remediate ${!isLicenseIssue ? row.cve : row.issueName}`} handleClose={handleClose} />
          <Box height={'100%'} p={3}>
            {!isLicenseIssue && (
              <NRRemediationContent
                inDrawer={true}
                cve={row.cve}
                dependencyComponentId={row.componentId}
                onResponseExtraActions={onSubmit}
                onCancelExtraActions={() => setOpenLocalDrawer(false)}
              />
            )}
            {!!isLicenseIssue && (
              <NRLicenseIssueRemediationContent
                licenseIssues={[row]}
                inDrawer={true}
                onResponseExtraActions={onSubmit}
                onCancelExtraActions={() => setOpenLocalDrawer(false)}
              />
            )}
          </Box>
        </DrawerMainContainer>
      </Drawer>
    </Box>
  );
}
export default RemediationButtonDrawerContainer;
